import h from "../core/createElement";
import { switchable_element } from "../utils";


export default function Box({ title = "", buttons = [], containerClass, minimizable = false, minimized = false, name = "box", shared = {} }, children) {
    const minimize_btn = switchable_element(<button class="box-btn-arrow" onClick={() => box.classList.toggle("minimized")} />);

    /** @type {HTMLElement} */
    const box = (
        <section class={"box " + (containerClass ?? "") + ((minimizable && minimized) ? " minimized" : "")}>
            <section class="header">
                <div class="title-container">
                    {minimizable ? minimize_btn.current() : ""}
                    <span class="title">{title}</span>
                </div>
                <div class="btns">
                    {buttons}
                </div>
            </section>
            <section class="body">
                {children}
            </section>
        </section>
    );

    shared[name] = {
        hightlight_on_overlay: () => {
            box.classList.remove("minimized");
            box.classList.add("highlighted-in-overlay");
            minimize_btn.hide();
        },
        dismiss_hightlight: () => {
            box.classList.remove("highlighted-in-overlay");
            minimize_btn.show();
        }
    };

    return box;
};
